import { Component, inject, OnInit } from '@angular/core';
import { PageHeaderComponent } from '@/components/shared/page-header/page-header.component';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { CompanyService } from '../company.service';
import { CompanyRepository } from '@/store/company-state/company-state.repository';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { RefParamsService } from '../../ref-params/ref-params.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { getInspectCompanyFormObject } from '../utils/inspect-company-form-object';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from 'primeng/tabs';
import { ActivityComponent } from '../../activity/activity.component';
import { CompanyMembersComponent } from '@/components/shared/company-members/company-members.component';
import { CompanyDetails } from '@/types';

@Component({
  selector: 'sm-inspect-company',
  imports: [
    PageHeaderComponent,
    FormBuilderComponent,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    TranslateModule,
    ActivityComponent,
    CompanyMembersComponent,
  ],
  templateUrl: './inspect-company.component.html',
  styleUrl: './inspect-company.component.scss',
})
export class InspectCompanyComponent implements OnInit {
  companyService = inject(CompanyService);
  companyRepository = inject(CompanyRepository);
  refParamsService = inject(RefParamsService);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);
  router = inject(Router);

  breadcrumb = [
    {
      label: 'settings.companyInfo.breadcrumb.parametres',
      routerLink: ['/settings'],
    },
    {
      label: 'settings.companyInfo.breadcrumb.companyInfo',
      routerLink: ['/settings', 'company'],
    },
    {
      label: 'settings.companyInfo.breadcrumb.consult',
      routerLink: ['/settings', 'company', 'consult'],
    },
  ];

  selectedTab = '0';

  company!: CompanyDetails;

  id = 0;
  companiesTypesOptions: { name: string; code: number }[] = [];
  companyCategoriesOptions: { name: string; code: number }[] = [];
  companyCountriesOptions: { name: string; code: number }[] = [];

  formObject: any = null;

  ngOnInit(): void {
    this.initRouting();
    this.companyService.getOneCompany(this.id).subscribe({
      next: response => {
        this.company = response;
        this.companyRepository.set('dto', {
          nom: response.nom,
          typeId: response.type?.id,
          nif: response.nif,
          dateNif: response.dateNif,
          numCnss: response.numCnss,
          address: response.address,
          categorieSoumissionnaireId: response.categorieSoumissionnaire?.id,
        });
        this.companyRepository.set('companyTypeSelected', {
          name: response.type?.code,
          code: response.type?.id,
        });
        this.companyRepository.set('companyCountrySelected', {
          name: response.address.pays.description,
          code: response.address.pays.id,
        });
        this.companyRepository.set('companyCategorySelected', {
          name: response.categorieSoumissionnaire?.code,
          code: response.categorieSoumissionnaire?.id,
        });
        this.companiesTypesOptions = [{ name: response.type?.code, code: response.type?.id }];
        this.companyCategoriesOptions = [{ name: response.categorieSoumissionnaire?.code, code: response.categorieSoumissionnaire?.id }];
        this.companyCountriesOptions = [{ name: response.address.pays.description, code: response.address.pays.id }];

        this.formObject = getInspectCompanyFormObject({
          store: this.companyRepository,
          companiesTypesOptions: this.companiesTypesOptions,
          companyCategoriesOptions: this.companyCategoriesOptions,
          companyCountriesOptions: this.companyCountriesOptions,
        });
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: this.translate.instant('settings.company.message.error.loading'),
        });
      },
    });
  }

  initRouting() {
    this.id = Number(this.activatedRoute.snapshot.paramMap.get('id'));
  }

  onTabChange(event: any) {
    this.selectedTab = event;
    this.router.navigate([], {
      fragment: event,
      replaceUrl: true,
    });
  }
}
